function ensureInitCards() {
  if (typeof window.initCards === "function") return Promise.resolve(true);

  return new Promise((resolve) => {
    const scripts = document.querySelectorAll("script");
    for (const s of scripts) {
      if (s.textContent.includes("window.initCards")) {
        try {
          eval(s.textContent);
          return resolve(true);
        } catch (e) {
          console.warn("⚠️ Failed to re-evaluate inline initCards:", e);
        }
      }
    }
    resolve(false);
  });
}

async function safeReinitUpsells(reason = "") {
  await ensureInitCards();
  if (typeof window.initCards === "function") {
    window.initCards();
  } else {
    console.warn("⚠️ initCards still not available");
  }
}

// --- Drawer events ---
document.addEventListener("cart:open", () => safeReinitUpsells("cart:open"));
document.addEventListener("cart:rerender", () => safeReinitUpsells("cart:rerender"));

// --- Patch fetch to detect ANY cart modification ---
const originalFetch = window.fetch;
window.fetch = async function (...args) {
  const [resource, config] = args;
  const url = typeof resource === "string" ? resource : resource.url;

  const modifiesCart =
    url.includes("/cart/add") ||
    url.includes("/cart/update") ||
    url.includes("/cart/change") ||  // <-- deletions & qty changes
    url.includes("/cart/clear");

  const response = await originalFetch.apply(this, args);

  if (modifiesCart && response.ok) {
    setTimeout(() => safeReinitUpsells("fetch:cart change"), 300);
  }

  return response;
};

// --- Patch XMLHttpRequest for legacy code (optional) ---
const XHR = XMLHttpRequest.prototype;
const open = XHR.open;
XHR.open = function (method, url, ...rest) {
  this._isCartRequest = url.includes("/cart/");
  return open.apply(this, [method, url, ...rest]);
};
const send = XHR.send;
XHR.send = function (...args) {
  this.addEventListener("load", function () {
    if (this._isCartRequest && this.status >= 200 && this.status < 300) {
      setTimeout(() => safeReinitUpsells("XHR:cart change"), 300);
    }
  });
  return send.apply(this, args);
};